import { Autocomplete, Box, Chip, TextField } from "@mui/material";
import * as React from "react";
import { CustomTextInput } from "./style";

export default function ChipBasedTextField({ label, id, values, onChangeCall, fieldErrors }) {

    // Function to add multiple comma-separated values
    const addCommaSeparatedValues = (rawValue) => {
        const newValues = rawValue
            .split(",")
            .map(v => v.trim())
            .filter(v => v !== "");

        if (newValues.length > 0) {
            const merged = [...new Set([...values, ...newValues])];
            onChangeCall(merged);
        }
    };

    return <Autocomplete
        multiple
        id={typeof id !== "undefined" ? id : "chip-based-text-field"}
        fullWidth={true}
        options={[]}
        noOptionsText="No matches found"
        value={values}
        freeSolo
        autoFocus={false}
        size="small"
        onChange={(e, newValue, reason) => {
            // Ignore freeSolo auto-commit
            if (reason === "createOption") return;

            onChangeCall(newValue);
        }}
        renderTags={(value, getItemProps) =>
            value.map((option, index) => {
                const { key, ...itemProps } = getItemProps({ index });
                return (
                    <Chip
                        variant="filled"
                        label={option}
                        key={key}
                        size='small'
                        sx={{
                            backgroundColor: "#AF3241",
                            color: "#FFFFFF",
                            '& .MuiChip-deleteIcon': {
                                color: "#FFFFFF",
                            },
                        }}
                        {...itemProps} />
                );
            })
        }
        renderInput={(params) => (
            <CustomTextInput
                {...params}
                autoFocus={false}
                autoComplete="off"
                fullWidth={true}
                label={label}
                variant="standard"
                required={false}
                error={fieldErrors !== "" ? true : false}
                helperText={fieldErrors !== "" ? fieldErrors : ""}
                onKeyDown={(e) => {
                    if (
                        e.key === "Backspace" &&
                        e.target.value === ""
                    ) {
                        e.stopPropagation();
                    }

                    // Commit values on Enter
                    if (e.key === "Enter" && e.target.value.trim()) {
                        e.preventDefault();
                        addCommaSeparatedValues(e.target.value);
                    }
                }}
                onPaste={(e) => {
                    const pasted = e.clipboardData.getData("text");
                    if (pasted.includes(",")) {
                        e.preventDefault();
                        addCommaSeparatedValues(pasted);
                    }
                }}
            />
        )}
    />;
}
